// import AdminCreate from './Create'
import AdminList from './List'
import AdminEdit from './Edit'
import AdminShow from './Show'
import AdminCreate from './Create'

const adminResource = {
  list: AdminList,
  create: AdminCreate,
  edit: AdminEdit,
  show: AdminShow,
}

export default adminResource
